import angular from 'angular';
import template from './template.html';
import './style.scss';
import { Inject } from '../../../base/decorators';
import BaseComponent from '../../../base/component';

export class BasePopup extends BaseComponent {
    @Inject('$filter') $filter;
    content = '';
    showContent = false;

    async setupContent() {
        const cachedContent = this.getContentFromCache();

        if (cachedContent) {
            this.content = cachedContent;

            return;
        }

        this.content = this.$filter('translate')('LOADING_TOOLTIP');
        const loadedContent = await this.loadContent();

        this.setContentToCache(loadedContent);

        this.content = loadedContent;
        this.applyScope();
    }

    loadContent() {}

    getContentFromCache() {}

    setContentToCache() {}

    onHover() {
        this.showContent = true;

        this.setupContent();
    }

    onLeave() {
        this.showContent = false;
    }
}

export const BasePopupConfiguration = {
    template,
    controller: BasePopup,
    bindings: {
        iconClass: '@',
    },
    controllerAs: 'basePopupCtrl',
};

angular.module('TALENYA-FE').component('base-popup', BasePopupConfiguration);